<main class="reference_form-main">
  <div class="main_container">
    <form [formGroup]="securityclassificationForm">
    <div class="">
      <h3 class="form_name">SecurityClassification</h3>


        <div class="input">
          <label for="">SecurityClassification Name</label>
          <input type="text" class="default_input reference-form" formControlName="SecurityClassificationName" />
        </div>
        <div class="input">
          <label for="">SecurityClassification Code</label>
          <input type="text" class="default_input reference-form" formControlName="SecurityCodeName" />
        </div>
        <div class="input">
          <label for="">Description</label>
          <input type="text" class="default_input reference-form" formControlName="Description" />
        </div>

      <div class="btn_holder">
        <button class="default_primary-button" *ngIf="selectedIndex === null" 
          (click)="addNew(securityclassificationForm.value)">Add</button>
        <button class="default_primary-button" *ngIf="selectedIndex !== null"
          (click)="addNew(securityclassificationForm.value)">Update</button>
        <button class="default_secondary-btn ml-2" (click)="onClearForm()">Reset</button>
      </div>

    </div>
  </form>
    <div class="display_table">
      <div class="search_container">
        <input type="text" class="default_input search"
        placeholder="Search for SecurityClassification"
        [formControl]="control"
        [appAutocomplete]="autocomplete"
        />
        <em class="ti-search"></em> 

        <app-autocomplete #autocomplete="appAutocomplete">
          <ng-template appAutocompleteContent>
            <ng-container
              *ngIf="(securityclassifications | filterReference: control.value) as result"
            >
              <app-option
                (click)="selectSecurityClassification(option.id)"
                *ngFor="let option of result"
                [value]="option.SecurityClassificationName"
              >
                {{ option.SecurityClassificationName }}
              </app-option>
              <app-option class="no-result" *ngIf="!result.length"
                >No result...</app-option
              >
            </ng-container>
          </ng-template>
        </app-autocomplete>
      </div>

      <div class="head" >
        <span class="item">S/N</span>
        <span class="item">SecurityClassification Name</span>
        <span class="item">Security Code Name</span>
        <span class="item">Description</span>
        <span class="item">Action</span>

      </div>

    <div class="scroll">

    </div>
    <div class="body_content" >
      <div class="the_body"
      *ngFor="let securityclassification of securityclassificationFormArray.get('SecurityClassifications')['controls']; index as i"
      (click)="onEdit(i, securityclassification.value)" style="cursor: pointer;"
      matTooltip="Click to edit"
        aria-label="Button that displays a tooltip when focused or hovered over"
      >
        <span class="content">{{i + 1}}</span>
        <span class="content">{{securityclassification.value.SecurityClassificationName}}</span>
        <span class="content">{{securityclassification.value.SecurityCodeName}}</span>
        <span class="content">{{securityclassification.value.Description}}</span>
        <span class="content" (click)="$event.stopImmediatePropagation()">
          <button
          class="delete_icon trash"

          (click)="deleteSecurityClassification(i, securityclassification.value)">
          <em class="ti-trash"> </em> </button>
        </span>

      </div>
      </div>
      <div class="btn_holder">
        <button class="default_primary-button" (click)="onSubmit(securityclassificationFormArray.value)">Submit</button>
      </div>
    </div>
  </div>
</main>

<div class="box green_box"></div>
<div class="box pink_box"></div>
